import _ from 'lodash';
import { DetailServiceSymbol } from '@/services/DetailService';
import { patentEditCommentService } from '@/presentation/pages/detail/basic/service/CommentService';
import { injectService } from '@/inversify.config';
export function useEditComments(option = {}) {
    const { canEdit, patent } = option;
    const detailService = injectService(DetailServiceSymbol);
    let _canEdit = canEdit;
    if (!_.has(option, 'canEdit')) {
        _canEdit = _.get(detailService.setting, 'fields.comment.delete', false);
    }
    patentEditCommentService.open({ patent, canEdit: _canEdit });
}
